/* Languange TH */

var thFooter = {
  "footer.desc"         : "แพลตฟอร์มการตลาดครบวงจรสำหรับครีเอเตอร์ที่คุณต้องการ เราสร้างแพลตฟอร์มที่อำนวยความสะดวกในการสร้างแคมเปญเพื่อให้ครีเอเดตอร์ แบรนด์ และเอเจนซี่ได้ทำงานร่วมกัน",
};
  
export default thFooter;